module.exports = __webpack_public_path__ + "img/Jump Casting6.f9c47b24.jpg";